export const GAME_TITLE = "Connections";
export const MAX_MISTAKES = 4;
